import { useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let internal = useDataValue({
    viewPath: props.viewPath,
    context: 'replace',
    path: 'selected_patient',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    if (typeof props.onReplaceMatch === 'function') {
      props.onReplaceMatch(internal)
    }
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
